import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { JsonLd } from '../JsonLd.js';

var WebPage = (_param)=>{
    var { pageType , url  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "pageType",
        "url"
    ]);
    const cleanUrl = url === null || url === void 0 ? void 0 : url.split('?')[0];
    if (!cleanUrl) {
        return null;
    }
    const payload = swcHelpers.objectSpread({
        '@type': 'WebPage',
        '@id': cleanUrl
    }, pageType ? {
        additionalType: `https://grandvision.com/#/PageType/${pageType}`
    } : {}, rest, {
        url: cleanUrl
    });
    return /*#__PURE__*/ React.createElement(JsonLd, swcHelpers.extends({}, payload));
};

export { WebPage };
//# sourceMappingURL=WebPage.sd.js.map
